// extracted by mini-css-extract-plugin
module.exports = {"header":"Header--header--28-mG","move":"Header--move--2--qV","header__container":"Header--header__container--3a_BD","header__logo":"Header--header__logo--2Pboo"};